import { Box, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import React from "react";
import { Text } from "@chakra-ui/react";
import { applyPrecision } from "infra/helpers/applyPrecision";

interface FracaoChartLegendProps {
  sumValues: number;
  remainingValue: number;
}

const LegendItem = ({
  color,
  text,
  value,
}: {
  color: string;
  text: string;
  value: number;
}) => (
  <Flex h="60px">
    <Box h="100%" w="8px" rounded="full" bg={color} mr={3} />
    <Flex flexDir="column">
      <Text fontSize={16} mt={-1}>
        {text}
      </Text>
      <Text fontWeight={"700"} fontSize={22} mt="4px">
        {applyPrecision(value, 5)}%
      </Text>
    </Flex>
  </Flex>
);

function FracaoChartLegend({
  sumValues,
  remainingValue,
}: FracaoChartLegendProps) {
  return (
    <Flex mx="auto" w="100%" justifyContent="space-evenly" mt={8}>
      <LegendItem text="Soma" value={sumValues} color={colors.primary} />

      <LegendItem text="Restam" value={remainingValue} color={colors.gray} />
    </Flex>
  );
}

export default FracaoChartLegend;
